import React, {Component, Fragment} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {formsUpdater, getFormFieldValue} from "../../Applications/shared/shared";
import {EventClient} from "../../../util/eventClient";
import {getData, postData} from "../../../api/doLogin";
import {isNumber} from "../../../util/numberhelpers";
import {getAARResultsByType, getAARStatus} from "../../../constants/AARConstants";
import {toast} from "react-toastify";
import {hasPermission, RequiredPermission} from "../../../api/permissionHelper";
import {LoadingOverlay} from "../../../components/Shared/LoadingOverlay";
import {AARQuestionnaireDialog} from "../modals/AARQuestionnaireDialog";
import {addLine, emptyDefault, getDataLine} from "../../../util/stringhelpers";
import {getGlobalState} from "../../../constants/GlobalStore";
import {stdTimezoneOffset} from "../../../util/datehelpers";

export default class AAREntryEditor extends Component {

  constructor(props) {
    super(props);
    this.original_status = props.aarData.subStatus && props.aarData.subStatus > 0 ? props.aarData.subStatus : props.aarData.aar_status !== 1 && props.aarData.aar_status !== 11 ? props.aarData.aar_status : "";
    this.state = {
      appttypes: [],
      products: [],
      dataLoaded: false,
      formData: {
        aar_status: this.original_status,
        notes: props.aarData.aar_comments || "",
        questionaire: props.aarData.questionaire || {},
        separation: props["attachedLead"]["separation"] || "",
      },
      event_comments: props.aarData && props.aarData.event_comments || "",
      showLMSPicker: false,
      readonly: false,
      processing: false,
      editMode: false,
      showQuestionnaire: false
    };
    this.loginID = getGlobalState('loginID');
  }

  componentWillMount() {
    if (!this.props.embedded) {
      EventClient.on(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    }
    this.getDBConstants();
  }

  componentWillUnmount() {
    if (!this.props.embedded) {
      EventClient.off(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    }
  }

  saveExternal() {
    // console.log(this.state.formData);
    this.save((resp) => {
      if (this.props.onSave) {
        this.props.onSave({aar_status: this.state.formData.aar_status, aar_comments: this.state.formData.notes});
      }
    })
  }

  saveInternval() {

  }

  getDBConstants() {
    const self = this;
    getData("calendar/retrieve-aar/" + this.props.edit || 0, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          let responseStateData = {
            appttypes: data.data.apptTypes || [],
            products: data.data.products || [],
            dataLoaded: true,
            readonly: false,
            editMode: false
          };
          // console.log(data.data);

          self.setState(responseStateData);
        }
      }).catch((error) => {
       console.log(error);
    });
  }

  saveEventDetails(cb) {
    let deletedENotes = this.state.formData.notes.replace(/[\n]*### EVENT DETAILS ###\n[\s\S]+### END EVENT DETAILS ###/gmi, "");
    deletedENotes = getDataLine([deletedENotes, "### EVENT DETAILS ###", this.props.aarData && this.props.aarData.event_comments || "", "### END EVENT DETAILS ###"], undefined, "", "\n");
    this.setState({formData: {...this.state.formData, notes: deletedENotes}}, cb);
  }

  save(cb) {
    const self = this;
    if (!this.props.attachedLead) {
      if (!confirm("You don't have a lead attached to this calendar. AAR comments will not transfer to lead notes. Do you want to continue?")) {
        return;
      }
    }
    if (getFormFieldValue(this.state.formData['aar_status']) === "") {
      toast.error("Unable to save. You need to select a status");
      return;
    }
    if (getFormFieldValue(this.state.formData["separation"]) === "") {
      toast.error("Unable to save. You must provide an ETS/DOS date");
      return;
    }
    const statusType = getAARStatus(getFormFieldValue(this.state.formData['aar_status']));
    const products = statusType.bcLinkVar === "sold" ? this.buildProducts(this.state.products || []) : [];
    const productsMinusFilter = products.filter(product => product.display !== "Referrals");
    if (statusType.bcLinkVar === "sold" && statusType.id !== 14 && productsMinusFilter.length === 0) {
      toast.error("Unable to save. You need to specify at least one sold type");
      return;
    }
    if (getFormFieldValue(this.state.formData['notes']) === "") {
      if (!confirm("Are you sure you want to submit without adding notes?")) {
        return;
      }
    }
    const payload = {
      formData: this.state.formData || null,
      action: isNumber(self.props.edit) ? "update" : "add",
      statusType: statusType,
      offset: stdTimezoneOffset()
    };
    if (payload['formData'] !== null) {
      payload['formData']['products'] = products;
    }
    if (this.props.edit && payload['formData']) {
      payload['formData']['id'] = this.props.edit;
    }
    // return console.log(payload);
    this.setState({processing: true});
    postData(`calendar/aar/save/${this.props.calId}/${this.props.edit}`, payload, this.props.token)
      .then((data) => {
        // console.log(data);
        this.setState({processing: false, editMode: false});
        if (data.status === "success") {
          if (!isNumber(self.props.edit)) {
            cb({...self.state.formData, id: data.data.id});
          } else {
            cb({...self.state.formData});
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  buildProducts(products) {
    return products.filter(product => {
      if (product['qty'] === "" || product['amount'] === "") {
        return false;
      } else {
        const display = product['display'];
        const qty = Number(product['qty']);
        const amount = Number(product['amount']);
        if (qty > 0 && amount >= 0) {
          return true;
        } else {
          return false;
        }
      }
    }).map(product => {
      const id = product['id'];
      const display = product['display'];
      const qty = Number(product['qty']);
      const amount = Number(product['amount']);
      return {id, display, qty, amount}
    });
  }

  productUpdate(product, key, value) {
    const newProducts = this.state.products.map((eachProd) => {
      if (eachProd.id === product.id) {
        return {...product, [key]: value}
      } else {
        return eachProd;
      }
    });
    this.setState({products: newProducts});
  }

  render() {
    if (!this.state.dataLoaded) {
      return <Fragment>Loading...</Fragment>;
    }
    const containerStyle = {
      zIndex: 1999
    };

    console.log(this.state)

    let disabledEdit = !this.state.editMode && this.original_status !== ""; // && this.original_status !== 11

    return (
      <Fragment>
        <LoadingOverlay show={this.state.processing}/>
        <Row>
          <Col xs="6" lg="6">
            <FormGroup>
              <Label for="aar_status">AAR Status</Label>
              <Input type="select" id="aar_status" placeholder=""
                     value={getFormFieldValue(this.state.formData['aar_status'])}
                     disabled={disabledEdit}
                     onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              >
                <option value={""} disabled>Please Select...</option>
                {this.props.aarData.aar_status === -1 && (
                  <option value={-1}>Rescheduled</option>
                )}
                {this.props.aarData.aar_status === -2 && (
                  <option value={-2}>Pushback</option>
                )}
                {this.props.aarData.aar_status === 0 && (
                  <option value={0}>Cancelled</option>
                )}
                {this.props.aarData.aar_status === 200 && (
                  <option value={200}>Cancelled DC</option>
                )}
                {(getAARResultsByType(this.props.apptType || 0) || []).map((val, i) => {
                  return <option key={i} value={val.id}>{val.display}</option>
                })}
              </Input>
            </FormGroup>
          </Col>
          <Col xs="6" lg="6">
            <FormGroup>
              <Label for="separation">ETS/DOS Date</Label>
              <Input
                  type="date"
                  id="separation"
                  disabled={disabledEdit}
                  placeholder="date"
                  value={getFormFieldValue(this.state.formData["separation"]).split("T")[0]}
                  onChange={(evt) => formsUpdater(evt, this.state.formData, this)}
              />
            </FormGroup>
          </Col>
        </Row>
        {this.state.products.length > 0 && getAARStatus(getFormFieldValue(this.state.formData['aar_status'])).bcLinkVar === "sold" && (
          <Row>
            {this.state.products.map((product, i) => {
              return <Col xs="4" lg="2" key={i}>
                <FormGroup>
                  <Label for="location">{product.display}</Label>
                  <div>Qty: #<Input
                    type="number"
                    value={product.qty}
                    min={0}
                    max={100}
                    disabled={disabledEdit}
                    onChange={(evt) => this.productUpdate(product, "qty", evt.target.value)}
                  /></div>
                  <div>
                    Amount: ($)<Input
                    type="number"
                    value={product.amount}
                    disabled={disabledEdit}
                    onChange={(evt) => this.productUpdate(product, "amount", evt.target.value)}
                  />
                  </div>
                </FormGroup>
              </Col>
            })}
          </Row>
        )}
        <Row>
          <Col xs="12">
            <FormGroup>
              <Label for="notes">Comments</Label>
              <Input
                type="textarea"
                id="notes"
                cols={15}
                disabled={disabledEdit}
                style={{height: 150}}
                value={getFormFieldValue(this.state.formData['notes'])}
                onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Fragment>
              {!disabledEdit && (
                <Fragment>
                  <Button color="primary"
                          onClick={() => this.saveEventDetails(() => this.save(() => {
                            this.original_status = getFormFieldValue(this.state.formData['aar_status']);
                            this.props.onSave && this.props.onSave({
                              aar_status: this.state.formData.aar_status,
                              aar_comments: this.state.formData.notes
                            });
                          }))}>Submit AAR</Button>
                  <Button color="default"
                          style={{marginLeft: 10}}
                          onClick={() => this.setState({showQuestionnaire: true})}>Use Questionnaire</Button>
                </Fragment>
              )}
              {disabledEdit && (hasPermission(RequiredPermission.CalendarAAREdit) || this.props.aarData.aar_uid === this.loginID) && this.props.aarData.aar_status > 0 && this.props.aarData.aar_status !== 200 && (
                <Fragment>
                  <Button color="info"
                          onClick={() => this.setState({editMode: true})}
                  >Edit AAR</Button>
                </Fragment>
              )}
            </Fragment>
          </Col>
        </Row>
        {this.state.showQuestionnaire && (
          <AARQuestionnaireDialog
            data={this.state.formData['questionaire'] || {}}
            defaults={{
              start_date: this.props.aarData.start_date,
              location: this.props.aarData.location,
              apptType: this.props.apptType
            }}
            onSave={(data) => {
              const savedNotes = this.formatNotes(this.state.formData['notes'] || "", this.parseQuestionnaire(data));
              this.setState({
                showQuestionnaire: false,
                formData: {...this.state.formData, questionaire: data, notes: savedNotes}
              });
            }}
            onClose={() => this.setState({showQuestionnaire: false})}
          />
        )}
      </Fragment>
    )
  }

  formatNotes(notes, questionnaireNotes) {
    let deletedQNotes = notes.replace(/[\n]*###AUTO QUESTIONNAIRE INPUT ###\n[\s\S]+###END QUESTIONNAIRE INPUT ###/gmi, "");
    if (questionnaireNotes.length === 0) return deletedQNotes;
    return getDataLine([deletedQNotes, "###AUTO QUESTIONNAIRE INPUT ###", questionnaireNotes, "###END QUESTIONNAIRE INPUT ###"], undefined, "", "\n");
  }

  parseQuestionnaire(formData) {
    var str = "";
    str = str + getDataLine([emptyDefault(formData.dateSeen, (new Date()).toDateString())], function (arr) {
      var response = "";
      response = addLine(response, `Date Seen: ${arr[0]}`);
      return response;
    });
    str = str + getDataLine([formData.fspBreakout1, formData.fspBreakout2, formData.fspEffectiveDate], function (arr) {
      var response = "";
      response = addLine(response, `FSP Breakout: $${arr[0]}/$${arr[1]}`);
      response = addLine(response, `FSP Draft/Effective Date: ${arr[2]}`);
      response = addLine(response, "");
      return response;
    });
    str = str + getDataLine([emptyDefault(formData.mbaMember, 0), emptyDefault(formData.mbaSpouse, 0)], function (arr) {
      if (arr[0] === 0 && arr[1] === 0) return undefined;
      var response = "";
      response = addLine(response, `MBA Coverage Amts: Member $${arr[0]} / Spouse $${arr[1]}`);
      response = addLine(response, "");
      return response;
    });
    str = str + getDataLine([emptyDefault(formData.tspTraditional, 0), emptyDefault(formData.tspRoth, 0), emptyDefault(formData.tspChanges, "no"), emptyDefault(formData.tspEffectiveDate, "n/a")], function (arr) {
      if (arr[0] === 0 && arr[1] === 0) return undefined;
      var response = "";
      response = addLine(response, `TSP/Roth Amts: $${arr[0]} / $${arr[1]}`);
      response = addLine(response, `Changes to TSP? ${arr[2]}`);
      if (arr[3] !== "n/a") {
        response = addLine(response, `Effective Date? ${arr[3]}`);
      }
      response = addLine(response, "");
      return response;
    });
    str = str + getDataLine([formData.amtCommitted], function (arr) {
      var response = "";
      response = addLine(response, `Amount client committed to before above changes occur: $${arr[0]}`);
      return response;
    });
    str = str + getDataLine([formData.timeInService], function (arr) {
      var response = "";
      response = addLine(response, `How long in military? ${arr[0]}`);
      return response;
    });
    str = str + getDataLine([formData.previouslySaved], function (arr) {
      var response = "";
      response = addLine(response, `How much do they have saved? $${arr[0]}`);
      return response;
    });
    str = str + getDataLine([formData.servicePlans], function (arr) {
      var response = "";
      response = addLine(response, `Planning on staying in or getting out? ${arr[0]}`);
      return response;
    });
    str = str + getDataLine([emptyDefault(formData.serviceLocation, "n/a"), emptyDefault(formData.serviceDescription, "n/a")], function (arr) {
      if (arr[0] === "n/a" && arr[1] === "n/a") return undefined;
      var response = "";
      response = addLine(response, `Where do they work, what do they do? ${arr.join(" / ")}`);
      return response;
    });
    str = str + getDataLine([formData.referralInfo], function (arr) {
      var response = "";
      response = addLine(response, `HOW DID WE GET THEIR NAME? ${arr[0]}`);
      return response;
    });
    str = str + getDataLine([formData.apptLocation], function (arr) {
      var response = "";
      response = addLine(response, `WHERE WAS THE APPT? ${arr[0]}`);
      return response;
    });
    str = str + getDataLine([formData.notes], function (arr) {
      var response = "";
      response = addLine(response, `Notes: ${arr[0]}`);
      return response;
    });
    return str;
  }
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/views/AAREntryEditor.js